import { useRef, useCallback, useEffect } from 'react'
import { useRefreshUser } from '../user/redux/refreshUser'

export const usePaymentPolling = (actions) => {
  const intRef = useRef(null)
  const { refreshUser } = useRefreshUser()

  const startPolling = useCallback(() => {
    if (intRef.current && intRef.current.int) {
      clearInterval(intRef.current.int)
    }

    intRef.current = {
      int: setInterval(() => {
        intRef.current.count++
        refreshUser()

        if (intRef.current.count >= 20) {
          clearInterval(intRef.current.int)
          intRef.current = null
        }
      }, 1500),
      count: 0
    }
  }, [refreshUser])

  const stopPolling = useCallback((setPaymentComplete = false) => {
    if (intRef.current && intRef.current.int) {
      clearInterval(intRef.current.int)
      intRef.current = null
      if (setPaymentComplete) {
        actions.setThing('paymentComplete', true)
      }
    }
  }, [actions])

  const isPolling = useCallback(() => {
    return intRef.current && intRef.current.int != null
  }, [])

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (intRef.current && intRef.current.int) {
        clearInterval(intRef.current.int)
      }
    }
  }, [])

  return { startPolling, stopPolling, isPolling }
}